import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
import { truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  typography = tokens.typography;
export var articleCard = /*#__PURE__*/css("width:100%;border-radius:3px;overflow:hidden;min-height:124px;display:flex;align-items:stretch;border:1px solid ", colors.neutral.trim.default, ";&:hover{box-shadow:0 5px 40px 0 ", colors.neutral.trim.default, ";}");
export var link = /*#__PURE__*/css("flex-grow:1;flex-direction:column;display:flex;text-decoration:none;color:", colors.neutral.heavy.default, ";");
export var content = /*#__PURE__*/css("display:flex;justify-content:space-between;align-items:stretch;flex-grow:1;border-top:6px solid ", colors.neutral.heavy.default, ";");
export var topImageContainer = {
  name: "9vjbcf",
  styles: "display:block;height:148px;width:auto;img{width:100%;height:100%;object-fit:cover;}"
};
export var leftImageContainer = {
  name: "1h2swia",
  styles: "display:block;width:90px;img{width:100%;min-width:90px;height:100%;object-fit:cover;}"
};
export var tags = {
  name: "1krlz36",
  styles: "display:flex;flex-wrap:wrap;overflow:hidden;max-height:24px;align-self:flex-start;gap:8px;"
};
export var tag = {
  name: "1xojai5",
  styles: "display:block;margin:0;text-shadow:none;text-overflow:ellipsis;max-width:171px;padding-top:2px;"
};
export var middle = {
  name: "px4k3f",
  styles: "display:flex;flex-direction:column;flex-grow:1;padding:16px;justify-content:space-between;gap:12px;"
};
export var heading = /*#__PURE__*/css(applyFont(typography.subheading));
var bodyLongLineHeight = 24;
export var description = _ref => {
  var fixedHeight = _ref.fixedHeight,
    maxLines = _ref.maxLines;
  return /*#__PURE__*/css(truncateLines(maxLines), " ", applyFont(typography.body), " line-height:", bodyLongLineHeight, "px;color:", colors.neutral.heavy.default, ";margin-bottom:16px;", fixedHeight && /*#__PURE__*/css("height:", maxLines * bodyLongLineHeight, "px;"));
};
export var arrow = {
  name: "1p57ph1",
  styles: "padding-top:16px;padding-right:10px;"
};